import type { GetImpactRatingCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactRatingCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetImpactRatingCount = createQueryHook<
  Record<string, never>,
  number,
  GetImpactRatingCountQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.impactRating.impactRatingCount.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    impact_rating_aggregate: {
      aggregate: {
        count: data ?? 0,
      },
    },
  }),
  graphqlDocument: GetImpactRatingCountDocument,
});
